export default __webpack_public_path__ + "components/page-header/static/weather-badge--light-61a11f6af8c7eb56c209be18f3e51486.svg";